(function () {
  var booted = false;
  var watching = false;

  function rootEl() {
    return document.getElementById("sep26-reusely");
  }

  function widgetMounted(root) {
    if (!root) return false;
    var host = root.querySelector(".buyback-widget") || root;
    if (host.querySelector("iframe, input, select, button, form")) return true;
    if (host.childElementCount > 3) return true;
    return false;
  }

  function restoreLazyScripts(root) {
    if (!root) return;
    var scripts = root.querySelectorAll('script[type="text/lazyload"], script[type="text/plain"]');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      var src = old.getAttribute("src") || old.getAttribute("data-src") || "";
      var text = old.textContent || "";
      if (!/reusely|Buyback/i.test(src + text)) continue;
      if (old.getAttribute("data-sep26-hydrated") === "1") continue;
      var s = document.createElement("script");
      if (src) s.src = src;
      else s.text = text;
      s.setAttribute("data-sep26-hydrated", "1");
      old.setAttribute("data-sep26-hydrated", "1");
      old.type = "text/sep26-skipped";
      old.parentNode.insertBefore(s, old);
    }
  }

  function extractConfig(root) {
    var scripts = root.querySelectorAll("script");
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent || "";
      var start = t.indexOf("new Buyback");
      if (start < 0) continue;
      var paren = t.indexOf("(", start);
      if (paren < 0) continue;
      var depth = 0;
      var end = -1;
      for (var j = paren; j < t.length; j++) {
        if (t[j] === "(") depth += 1;
        else if (t[j] === ")") {
          depth -= 1;
          if (depth === 0) {
            end = j;
            break;
          }
        }
      }
      if (end < 0) continue;
      try {
        return new Function("return (" + t.slice(paren + 1, end) + ")")();
      } catch (e) {}
    }
    return null;
  }

  function startWidget(cfg) {
    var root = rootEl();
    if (booted || !cfg || typeof window.Buyback !== "function") return;
    if (widgetMounted(root)) {
      booted = true;
      return;
    }
    booted = true;
    try {
      new window.Buyback(cfg);
    } catch (e) {
      booted = false;
    }
  }

  function ensureSdk() {
    if (typeof window.Buyback === "function") return;
    if (document.querySelector('script[src*="widget.reusely.com"]')) return;
    var s = document.createElement("script");
    s.src = "https://widget.reusely.com/v3.js";
    s.async = true;
    document.head.appendChild(s);
  }

  function boot() {
    var root = rootEl();
    if (!root) return;
    restoreLazyScripts(root);
    if (widgetMounted(root)) {
      booted = true;
      return;
    }
    if (watching) return;
    watching = true;
    ensureSdk();
    var cfg = extractConfig(root);
    var n = 0;
    var timer = setInterval(function () {
      n += 1;
      if (widgetMounted(rootEl())) {
        booted = true;
        clearInterval(timer);
        return;
      }
      if (typeof window.Buyback === "function" && cfg) {
        clearInterval(timer);
        startWidget(cfg);
        return;
      }
      if (n > 150) clearInterval(timer);
    }, 200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  window.addEventListener("load", boot);
})();
